import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import {RouterProvider, createBrowserRouter, Navigate} from 'react-router-dom'
import RootLayout from './layouts/root-layout'
import {SignInPage} from './routes/sign-in'
import {SignUpPage} from './routes/sign-up'
import reportWebVitals from "./reportWebVitals";
import {ThemeProvider} from "@mui/material";
import {theme} from "./theme";
import {ProtectedRoute} from "./layouts/ProtectedRoute";
import HomeLayout from "./layouts/HomeLayout";
import DashboardLayout from './layouts/DashboardLayout'
import CollectionLayout from './layouts/CollectionLayout'
import CollectionItemsLayout from './layouts/CollectionItemsLayout'
import ItemDetailLayout from './layouts/ItemDetailLayout'
import ItemEditLayout from './layouts/ItemEditLayout'

const router = createBrowserRouter([
    {
        element: <RootLayout/>,
        children: [
            {path: '/sign-in/*', element: <SignInPage/>},
            {path: '/sign-up/*', element: <SignUpPage/>},
            {path: '/', element: <Navigate to="/h/dashboard" replace/>},
            {path: '/h', element: <Navigate to="/h/dashboard" replace/>},
            {
                path: '/h',
                element: <ProtectedRoute> <HomeLayout/></ProtectedRoute>,
                children: [
                    {path: '/h/dashboard', element: <DashboardLayout/>},
                    {path: '/h/collections', element: <CollectionLayout/>},
                    {path: '/h/collection/:cid', element: <CollectionItemsLayout/>},
                    {path: '/h/collection/:cid/item/:iid', element: <ItemDetailLayout/>},
                    {path: '/h/collection/:cid/item/:iid/edit', element: <ItemEditLayout/>}
                ]
            },
        ],
    },
])

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <RouterProvider router={router}/>
        </ThemeProvider>
    </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
